<mat-toolbar class="d-flex flex-space-between mat-elevation-z3 noPrint" color="primary">
    <button [routerLink]="['/login']" aria-label="Home" mat-icon-button matTooltip="Home">
        <img alt="Virtual Memory Box Logo" height="24" ngSrc="assets/images/vmb.svg" width="24">
    </button>
</mat-toolbar>
<main class="minFullHeight" role="main">
    <div class="container d-flex justify-content-center">
        <div class="d-flex flex-column">

            <div class="text-center">
                <mat-card id="content">
                    <mat-card-header class="text-start">
                        <mat-card-title><b> VMB Status</b></mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <div class="flex-row">
                            <mat-list aria-live="polite" role="status">
                                <mat-list-item>

                                    <mat-icon class="success" matListItemIcon>check_circle
                                        
                                    </mat-icon>
                                    <div matListItemTitle>Serving Frontend</div>
                                    <div matListItemLine>Running</div>
                                </mat-list-item>
                                <mat-list-item>
                                    @if (cacheBackend !== null) {
                                        <mat-icon
                                                [class.error]="cacheBackend == false"
                                                [class.success]="cacheBackend"
                                                matListItemIcon>
                                            @if (cacheBackend) {
                                                check_circle
                                            } @else {
                                                block
                                            }
                                        </mat-icon>
                                    } @else {
                                        <mat-icon matListItemIcon>
                                            <mat-spinner [diameter]="24" aria-label="Checking status"></mat-spinner>
                                        </mat-icon>
                                    }
                                    <div matListItemTitle>Backend Cache</div>
                                    <div matListItemLine>
                                        @if (cacheBackend !== null) {
                                            @if (cacheBackend) {
                                                Running
                                            } @else {
                                                Failed
                                            }
                                        } @else {
                                            Checking...
                                        }
                                    </div>
                                </mat-list-item>
                                <mat-list-item>
                                    @if (databaseBackend !== null) {
                                        <mat-icon
                                                [class.error]="databaseBackend == false"
                                                [class.success]="databaseBackend"
                                                matListItemIcon>
                                            @if (databaseBackend) {
                                                check_circle
                                            } @else {
                                                block
                                            }
                                        </mat-icon>
                                    } @else {
                                        <mat-icon matListItemIcon>
                                            <mat-spinner [diameter]="24" aria-label="Checking status"></mat-spinner>
                                        </mat-icon>
                                    }
                                    <div matListItemTitle>Database</div>
                                    <div matListItemLine>
                                        @if (databaseBackend !== null) {
                                            @if (databaseBackend) {
                                                Running
                                            } @else {
                                                Failed
                                            }
                                        } @else {
                                            Checking...
                                        }
                                    </div>
                                </mat-list-item>
                                <mat-list-item>
                                    @if (defaultFileStorageHealthCheck !== null) {
                                        <mat-icon
                                                [class.error]="defaultFileStorageHealthCheck == false"
                                                [class.success]="defaultFileStorageHealthCheck"
                                                matListItemIcon>
                                            @if (defaultFileStorageHealthCheck) {
                                                check_circle
                                            } @else {
                                                block
                                            }
                                        </mat-icon>
                                    } @else {
                                        <mat-icon matListItemIcon>
                                            <mat-spinner [diameter]="24" aria-label="Checking status"></mat-spinner>
                                        </mat-icon>
                                    }
                                    <div matListItemTitle>File Storage</div>
                                    <div matListItemLine>
                                        @if (defaultFileStorageHealthCheck !== null) {
                                            @if (defaultFileStorageHealthCheck) {
                                                Running
                                            } @else {
                                                Failed
                                            }
                                        } @else {
                                            Checking...
                                        }
                                    </div>
                                </mat-list-item>
                                <mat-list-item>
                                    @if (diskUsage !== null) {
                                        <mat-icon [class.error]="diskUsage == false"
                                                  [class.success]="diskUsage"
                                                  matListItemIcon>
                                            @if (diskUsage) {
                                                check_circle
                                            } @else {
                                                block
                                            }
                                        </mat-icon>
                                    } @else {
                                        <mat-icon matListItemIcon>
                                            <mat-spinner [diameter]="24" aria-label="Checking status"></mat-spinner>
                                        </mat-icon>
                                    }
                                    <div matListItemTitle>Disk</div>
                                    <div matListItemLine>
                                        @if (diskUsage !== null) {
                                            @if (diskUsage) {
                                                Running
                                            } @else {
                                                Failed
                                            }
                                        } @else {
                                            Checking...
                                        }
                                    </div>
                                </mat-list-item>
                                <mat-list-item>
                                    @if (browserCheck) {
                                        <mat-icon [class.error]="browserCheck !== 'success'"
                                                  [class.success]="browserCheck === 'success'"
                                                  matListItemIcon>
                                            @if (browserCheck === 'success') {
                                                check_circle
                                            } @else {
                                                block
                                            }
                                        </mat-icon>
                                    } @else {
                                        <mat-icon matListItemIcon>
                                            <mat-spinner [diameter]="24" aria-label="Checking status"></mat-spinner>
                                        </mat-icon>
                                    }
                                    <div matListItemTitle>Browser</div>
                                    <div matListItemLine>
                                        @if (browserCheck) {
                                            @if (browserCheck === 'success') {
                                                Running
                                            } @else {
                                                {{ browserCheck }}
                                            }
                                        } @else {
                                            Checking...
                                        }
                                    </div>
                                </mat-list-item>
                                <mat-list-item>
                                    @if (clientTimeCheck !== null) {
                                        <mat-icon [class.error]="clientTimeCheck == false"
                                                  [class.success]="clientTimeCheck"
                                                  matListItemIcon>
                                            @if (clientTimeCheck) {
                                                check_circle
                                            } @else {
                                                block
                                            }
                                        </mat-icon>
                                    } @else {
                                        <mat-icon matListItemIcon>
                                            <mat-spinner [diameter]="24" aria-label="Checking status"></mat-spinner>
                                        </mat-icon>
                                    }
                                    <div matListItemTitle>Client Time</div>
                                    <div matListItemLine>
                                        @if (clientTimeCheck !== null) {
                                            {{ clientTime }}
                                        } @else {
                                            Checking...
                                        }
                                    </div>
                                    @if (clientTimezone) {
                                        <div matListItemLine>{{ clientTimezone }}</div>
                                    }
                                </mat-list-item>

                                @if (isRaa) {
                                    <mat-list-item>
                                        @if (raa !== null) {
                                            <mat-icon
                                                    [class.error]="raa == false"
                                                    [class.success]="raa"
                                                    matListItemIcon>
                                                @if (raa) {
                                                    check_circle
                                                } @else {
                                                    block
                                                }
                                            </mat-icon>
                                        } @else {
                                            <mat-icon matListItemIcon>
                                                <mat-spinner color="primary" width="40px"></mat-spinner>
                                            </mat-icon>
                                        }
                                        <div matListItemTitle>RAA Configuration</div>
                                        <div matListItemLine>
                                            @if (raa !== null) {
                                                @if (raa) {
                                                    Running
                                                } @else {
                                                    Failed
                                                }
                                            } @else {
                                                Checking...
                                            }
                                        </div>
                                    </mat-list-item>
                                }
                            </mat-list>
                            <mat-list>
                                <mat-list-item>
                                    @if (memoryUsage !== null) {
                                        <mat-icon
                                                [class.error]="memoryUsage == false"
                                                [class.success]="memoryUsage"
                                                matListItemIcon>
                                            @if (memoryUsage) {
                                                check_circle
                                            } @else {
                                                block
                                            }
                                        </mat-icon>
                                    } @else {
                                        <mat-icon matListItemIcon>
                                            <mat-spinner [diameter]="24" aria-label="Checking status"></mat-spinner>
                                        </mat-icon>
                                    }
                                    <div matListItemTitle>Memory</div>
                                    <div matListItemLine>
                                        @if (memoryUsage !== null) {
                                            @if (memoryUsage) {
                                                Running
                                            } @else {
                                                Failed
                                            }
                                        } @else {
                                            Checking...
                                        }
                                    </div>
                                </mat-list-item>
                                <mat-list-item>
                                    @if (migrationsHealthCheck !== null) {
                                        <mat-icon
                                                [class.error]="migrationsHealthCheck == false"
                                                [class.success]="migrationsHealthCheck"
                                                matListItemIcon>
                                            @if (migrationsHealthCheck) {
                                                check_circle
                                            } @else {
                                                block
                                            }
                                        </mat-icon>
                                    } @else {
                                        <mat-icon matListItemIcon>
                                            <mat-spinner [diameter]="24" aria-label="Checking status"></mat-spinner>
                                        </mat-icon>
                                    }
                                    <div matListItemTitle>Migrations</div>
                                    <div matListItemLine>
                                        @if (migrationsHealthCheck !== null) {
                                            @if (migrationsHealthCheck) {
                                                Running
                                            } @else {
                                                Failed
                                            }
                                        } @else {
                                            Checking...
                                        }
                                    </div>
                                </mat-list-item>
                                <mat-list-item>
                                    @if (redisHealthCheck !== null) {
                                        <mat-icon
                                                [class.error]="redisHealthCheck == false"
                                                [class.success]="redisHealthCheck"
                                                matListItemIcon>
                                            @if (redisHealthCheck) {
                                                check_circle
                                            } @else {
                                                block
                                            }
                                        </mat-icon>
                                    } @else {
                                        <mat-icon matListItemIcon>
                                            <mat-spinner [diameter]="24" aria-label="Checking status"></mat-spinner>
                                        </mat-icon>
                                    }
                                    <div matListItemTitle>Redis</div>
                                    <div matListItemLine>
                                        @if (redisHealthCheck !== null) {
                                            @if (redisHealthCheck) {
                                                Running
                                            } @else {
                                                Failed
                                            }
                                        } @else {
                                            Checking...
                                        }
                                    </div>
                                </mat-list-item>
                                <mat-list-item>
                                    @if (s3Boto3StorageHealthCheck !== null) {
                                        <mat-icon
                                                [class.error]="s3Boto3StorageHealthCheck == false"
                                                [class.success]="s3Boto3StorageHealthCheck"
                                                matListItemIcon>
                                            @if (s3Boto3StorageHealthCheck) {
                                                check_circle
                                            } @else {
                                                block
                                            }
                                        </mat-icon>
                                    } @else {
                                        <mat-icon matListItemIcon>
                                            <mat-spinner [diameter]="24" aria-label="Checking status"></mat-spinner>
                                        </mat-icon>
                                    }
                                    <div matListItemTitle>S3 Storage</div>
                                    <div matListItemLine>
                                        @if (s3Boto3StorageHealthCheck !== null) {
                                            @if (s3Boto3StorageHealthCheck) {
                                                Running
                                            } @else {
                                                Failed
                                            }
                                        } @else {
                                            Checking...
                                        }
                                    </div>
                                </mat-list-item>
                                <mat-list-item>
                                    @if (trainingContentAPI !== null) {
                                        <mat-icon
                                                [class.error]="trainingContentAPI == false"
                                                [class.success]="trainingContentAPI"
                                                matListItemIcon>
                                            @if (trainingContentAPI) {
                                                check_circle
                                            } @else {
                                                block
                                            }
                                        </mat-icon>
                                    } @else {
                                        <mat-icon matListItemIcon>
                                            <mat-spinner [diameter]="24" aria-label="Checking status"></mat-spinner>
                                        </mat-icon>
                                    }
                                    <div matListItemTitle>Training Content</div>
                                    <div matListItemLine>
                                        @if (trainingContentAPI !== null) {
                                            @if (trainingContentAPI) {
                                                Running
                                            } @else {
                                                Failed
                                            }
                                        } @else {
                                            Checking...
                                        }
                                    </div>
                                </mat-list-item>
                                <mat-list-item>
                                    @if (mail !== null) {
                                        <mat-icon
                                                [class.error]="mail == false"
                                                [class.success]="mail"
                                                matListItemIcon>
                                            @if (mail) {
                                                check_circle
                                            } @else {
                                                block
                                            }
                                        </mat-icon>
                                    } @else {
                                        <mat-icon matListItemIcon>
                                            <mat-spinner color="primary" width="40px"></mat-spinner>
                                        </mat-icon>
                                    }
                                    <div matListItemTitle>Mail</div>
                                    <div matListItemLine>
                                        @if (mail !== null) {
                                            @if (mail) {
                                                Running
                                            } @else {
                                                Failed
                                            }
                                        } @else {
                                            Checking...
                                        }
                                    </div>
                                </mat-list-item>
                                <mat-list-item>
                                    @if (mediaPermissionCheck) {
                                        <mat-icon [class.error]="mediaPermissionCheck !== 'success'"
                                                  [class.success]="mediaPermissionCheck === 'success'"
                                                  matListItemIcon>
                                            @if (mediaPermissionCheck === 'success') {
                                                check_circle
                                            } @else {
                                                block
                                            }
                                        </mat-icon>
                                    } @else {
                                        <mat-icon matListItemIcon>
                                            <mat-spinner [diameter]="24" aria-label="Checking status"></mat-spinner>
                                        </mat-icon>
                                    }
                                    <div matListItemTitle>Media Permissions</div>
                                    <div matListItemLine>
                                        @if (mediaPermissionCheck) {
                                            @if (mediaPermissionCheck === 'success') {
                                                Accessible
                                            } @else {
                                                {{ mediaPermissionCheck }}
                                            }
                                        } @else {
                                            Checking...
                                        }
                                    </div>
                                </mat-list-item>

                            </mat-list>
                        </div>
                        <div class="flex-col mw-500 text-start">
                            <b> Context</b>
                            <ul>
                                @if (userAgent) {
                                    <li><b>User Agent:</b>
                                        {{ userAgent }}
                                    </li>
                                }
                                @if (environment.apiUrl) {
                                    <li><b>API:</b>
                                        {{ environment.apiUrl }}
                                    </li>
                                }
                                @if (currentUser) {
                                    @if (currentUser.email) {
                                        <li><b>Email:</b>
                                            {{ currentUser.email }}
                                        </li>
                                    }
                                    @if (currentUser.id) {
                                        <li><b>ID:</b>
                                            {{ currentUser.id }}
                                        </li>
                                    }
                                    @if (currentUser.username) {
                                        <li><b>Username:</b>
                                            {{ currentUser.username }}
                                        </li>
                                    }
                                    @if (currentUser.role) {
                                        <li><b>Role:</b>
                                            {{ currentUser.role.name }}
                                        </li>
                                    }
                                    @if (currentUser.deleted) {
                                        <li><b>Deleted:</b>
                                            {{ currentUser.deleted }}
                                        </li>
                                    }
                                    @if (currentUser.locked) {
                                        <li><b>Locked:</b>
                                            {{ currentUser.locked }}
                                        </li>
                                    }
                                }
                            </ul>
                        </div>
                    </mat-card-content>
                    <mat-card-actions class="noPrint">
                        <button (click)="printInfo()" (keyup.enter)="printInfo();"
                                color="primary" mat-raised-button>
                            Take a screenshot
                        </button>
                    </mat-card-actions>
                </mat-card>
            </div>
        </div>
    </div>
</main>
<div class="noPrint">
    <app-footer></app-footer>
</div>